import axios from 'axios'
import store from './store'
import router from './router'
// import { Base64 } from 'js-base64'

const Code = {
    OK: 0,
    UNAUTHORIZED: 102,
    RPCERROR: 33
}

const api = {
  url (path) {
      // if('development' == process.env.NODE_ENV) {
      //     return 'https://hk.systec-pbx.net/api' + path
      // }
      // return '/api' + path
      return 'https://www.systechn.com/api' + path
  },
  option () {
      if(null != store.state.token) {
          return {
              "headers": {"Authorization": store.state.token}
          }
      } else {
          return {}
      }
  },
  get (path, yes, no) {
      axios.get(this.url(path), this.option())
      .then(function (response) {
          let data = response.data
          if(data.code == Code.OK) {
              if(yes) {
                  yes(response.data)
              }
          } else if (data.code == Code.UNAUTHORIZED) {
              console.log(data)

          } else if (data.code == Code.RPCERROR) {
              if(no) {
                  no(data)
              }
          } else {
              if(no) {
                  no(data)
              }
          }
      })
      .catch(function (error) {
          console.log(error)
          if(no) {
              no(error)
          }
      });
  },
  post (path, data, yes, no) {
      axios.post(this.url(path), data, this.option())
      .then(function (response) {
          let data = response.data
          if(data.code == Code.OK) {
              if(yes) {
                  yes(response.data)
              }
          } else if (data.code == Code.UNAUTHORIZED) {
              console.log(data)
          } else if (data.code == Code.RPCERROR) {
              if(no) {
                  no(data)
              }
          } else {
              if(no) {
                  no(data)
              }
          }
      })
      .catch(function (error) {
          console.log(error)
          if(no) {
              no(error)
          }
      });
  },
  sendEmail (content, yes, no) {
      let data = {
          "subject" : "测试邮件",
          "body" : content
      }
      this.post(`/email`, data, yes, no)
  }
}





export default api
